<script setup lang="ts">
import BaseModal from '@/components/modal/BaseModal.vue';
import ModalFooterConfirmButtons from '@/components/modal/ModalFooterConfirmButtons.vue';
import { useModalStore } from '@/stores/modal';

const modalStore = useModalStore();

const handleClose = () => {
  modalStore.close();
};

const handleSubmit = () => {
  window.open('https://forms.gle/Sdrzg8EVE8m1WkLv6', '_blank', 'noopener,noreferrer');
};

const handleHelpLink = () => {
  window.open('https://www.youtube.com/watch?v=WFfx2ZQCuHw&feature=youtu.be', '_blank', 'noopener,noreferrer');
};
</script>

<template>
  <BaseModal title="로그인 안내" aria-label="로그인 안내" width="400px" @close="handleClose">
    <div class="login-help-body">
      <p class="text-base text-[#404040] mb-3">
        마이정토는 정토회 회원 전용 사이트입니다.
      </p>
      <p class="text-base text-[#404040] mb-3">
        정토회원이 아니면 이용하실 수 없습니다.
      </p>
      <p class="text-base text-[#404040] mb-4">
        로그인 오류에 대해 담당자의 도움을 받고 싶은 회원은 아래 접수하기 버튼을 눌러서 설문지를 작성해주세요.
      </p>
      <a
        href="#"
        @click.prevent="handleHelpLink"
        class="text-base text-primary-500 underline hover:text-[#d67a3d] transition-colors inline-block"
      >
        로그인 도움말
      </a>
    </div>
    <template #footer>
      <div class="w-full">
        <ModalFooterConfirmButtons
          cancel-text="닫기"
          confirm-text="접수하기"
          :show-cancel="true"
          @cancel="handleClose"
          @confirm="handleSubmit"
        />
      </div>
    </template>
  </BaseModal>
</template>

<style scoped>
.login-help-body {
  display: flex;
  flex-direction: column;
  min-height: 180px;
  padding: 10px 0;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .login-help-body {
    min-height: 160px;
    font-size: 15px;
  }
}
</style>

